import { c as _c } from "react/compiler-runtime";
import debounce from 'lodash.debounce';
import { useLayoutEffect, useRef, useState } from 'react';
import Avatar from 'shared/components/header/components/avatar';
import { DesktopMenu } from 'shared/components/header/components/desktop-menu';
import { HeaderBase } from 'shared/components/header/components/header-base';
import SideMenu from 'shared/components/header/components/side-menu';
import SioButton from 'shared/components/header/components/sio-button';
import WorkspaceSelector from 'shared/components/header/components/workspace-selector';
import { DesktopLanguageSwitcher } from 'shared/components/language-switcher/desktop-language-switcher';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import useSWR from 'swr';
export const useActualHeaderLayoutType = () => {
  const $ = _c(5);
  const {
    data,
    mutate
  } = useSWR("header-layout-type");
  let t0;
  if ($[0] !== mutate) {
    t0 = desktop => mutate(desktop, false);
    $[0] = mutate;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== data || $[3] !== t0) {
    t1 = {
      isDesktop: data,
      setIsDesktop: t0
    };
    $[2] = data;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
function Header() {
  const $ = _c(12);
  const [isOpen, setIsOpen] = useState(false);
  const {
    isLoading,
    user
  } = useUser();
  const {
    i18n
  } = useLocoTranslation();
  const navRef = useRef(null);
  const workspaceRef = useRef(null);
  const sideMenuRef = useRef(null);
  const desktopMenuRef = useRef(null);
  const avatarRef = useRef(null);
  const {
    setIsDesktop
  } = useActualHeaderLayoutType();
  let t0;
  if ($[0] !== setIsDesktop) {
    t0 = () => {
      const handleResize = debounce(() => {
        const nav = navRef.current;
        const desktopMenu = desktopMenuRef.current;
        const sideMenu = sideMenuRef.current;
        const avatar = avatarRef.current;
        const workspace = workspaceRef.current;
        if (!desktopMenu || !sideMenu || !nav || !avatar || !workspace) {
          return;
        }
        const showDesktopElements = () => {
          desktopMenu.classList.remove("hidden");
          avatar.classList.remove("hidden");
          workspace.classList.remove("hidden");
          desktopMenu.classList.add("flex");
          avatar.classList.add("flex");
          workspace.classList.add("flex");
          sideMenu.classList.add("hidden");
          sideMenu.classList.remove("flex");
          setIsDesktop(true);
        };
        const showMobileElements = () => {
          desktopMenu.classList.remove("flex");
          avatar.classList.remove("flex");
          workspace.classList.remove("flex");
          desktopMenu.classList.add("hidden");
          avatar.classList.add("hidden");
          workspace.classList.add("hidden");
          sideMenu.classList.remove("hidden");
          sideMenu.classList.add("flex");
          setIsDesktop(false);
        };
        if (document.body.getBoundingClientRect().width < 1024) {
          showMobileElements();
          return;
        }
        if (nav.scrollWidth > nav.offsetWidth) {
          showMobileElements();
        } else {
          showDesktopElements();
          if (nav.scrollWidth > nav.offsetWidth) {
            showMobileElements();
          }
        }
      }, 300, {
        leading: true,
        trailing: true
      });
      handleResize();
      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    };
    $[0] = setIsDesktop;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = i18n?.language;
  const t2 = user?.dashboardLocale;
  let t3;
  if ($[2] !== isLoading || $[3] !== t1 || $[4] !== t2) {
    t3 = [t1, isLoading, t2];
    $[2] = isLoading;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useLayoutEffect(t0, t3);
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SioButton />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex items-center gap-4">{t4}<div ref={workspaceRef} className="flex"><WorkspaceSelector /></div></div>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div ref={desktopMenuRef} className="ml-auto flex h-full"><DesktopMenu /></div>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div ref={avatarRef} className="flex h-full shrink-0 items-center justify-around gap-4"><Avatar /><DesktopLanguageSwitcher /></div>;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== isOpen) {
    t8 = <HeaderBase ref={navRef}>{t5}{t6}{t7}<div ref={sideMenuRef} className="hidden"><SideMenu isOpen={isOpen} setIsOpen={setIsOpen} /></div></HeaderBase>;
    $[10] = isOpen;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
}
export default Header;